import { defineStore, storeToRefs } from "pinia";
import axios from 'axios';
import { ErrorDescription } from "./ErrorDescription";
import { BFilter, BFilterOptions, BFilterableField } from "@/components/BFilterEditor/BFilterEditor.types";
import { BSortOptions, BTableColumn, BTableOptions, serializeSortBy } from "@/components/BTable/BTable.types";
import { FailedFileDetails, FetchValidationMessagesResponse, UploadType, UploadedFileDetails } from "@/types";
import { defaultDataUploadDetailsColumns, defaultStatisticsColumns, defaultValidationMessagesColumns, defaultValidationMessagesFilterableFields } from "@/tableDefaults";
import { computed, ref } from "vue";
import { useBaseStore } from "./baseStore";
import { useOriStore } from "./oriStore";


export const usePoliceEmployeeStore = defineStore('policeEmployeeStore', () => {

    var baseStore = useBaseStore();
    baseStore.apiUrl.value = "api/v1/police-employee";
    baseStore.dataset.value = UploadType.policeEmployee;
    
    var oriStore = useOriStore();
    oriStore.reset();
    oriStore.dataset = UploadType.policeEmployee;    
    
    var getStatisticsColumns = computed(()=>{
        return defaultStatisticsColumns;
    });

    var getColumns = computed(()=>{
        return defaultDataUploadDetailsColumns;
    });

    var getFilterableFields = computed(() => {
        return baseStore.getDefaultFilterableFields;
    });
    
    var getValidationMessagesColumns = computed(()=>{
        return defaultValidationMessagesColumns;
    });
    
    var getValidationMessagesFilterableFields = computed(()=>{
        return defaultValidationMessagesFilterableFields;
    });

    var showWarningDetails = computed(()=>{
        return true;
    });
    
    var errorCodes = computed(()=> {
        return baseStore.errorCodes;
    });

    var errorDescriptions = computed(()=> {
        return baseStore.errorDescriptions;
    });

    function getValidationMessagesForFile(id: number, pageNumber: number, pageSize: number, filterInfo: BFilter[], filterableFields: BFilterableField[], sortingInfo: BSortOptions[]) {
        return baseStore.getValidationMessagesForFile(id, pageNumber, pageSize, filterInfo, filterableFields, sortingInfo);
    }
    
    function getRecordDetails(id: number) {            
        return baseStore.getRecordDetails(id);
    }

    function getErrorsAndWarnings(filters: BFilter[], tableOptions: BTableOptions, filterableFields: BFilterableField[], sortingInfo: BSortOptions[]) {
            return baseStore.getErrorsAndWarnings(tableOptions,filters, filterableFields )
    }

    function getErrorsAndWarningsForFile(id: number, filters: BFilter[], tableOptions: BTableOptions, filterableFields: BFilterableField[], sortingInfo: BSortOptions[]) {

        if (id >= 0 && !filters.some((filter, index, array) => { return (filter.property == "id"); })) {
            filters.push({ property: "id", operation: "eq", value: id } as BFilter)
        }

        return baseStore.getErrorsAndWarningsForUploadDetails(tableOptions,filters, filterableFields )
    }

    var getErrorsAndWarningsColumns = baseStore.getErrorsAndWarningsColumns;
    function getFilterableFieldsForErrorsAndWarnings(onlyHasOneOri:boolean,showAdditionalColumns:boolean, onlyIncludePrimaryColumns:boolean) {
        
        var ewFilters = baseStore.getFilterableFieldsForErrorsAndWarnings(onlyHasOneOri, showAdditionalColumns, onlyIncludePrimaryColumns);

        var agencyFilter = ewFilters.find(f=>f.property=="agency");
        if(agencyFilter){
            agencyFilter.editorOptions = oriStore.getOrisAsBFieldSelectionArray;
        }            

        return ewFilters;
    }

    function getFiles(filters: BFilter[], tableOptions: BTableOptions, filterableFields: BFilterableField[], sortingInfo: BSortOptions[]) {
        // if there's no total then were going to return the requested row count plus 1 so that we know when to disable to next page button
        return baseStore.getFiles(tableOptions, filters ?? [], filterableFields )
    }
    var getFileUploadColumns = baseStore.getFileUploadColumns;
    function getFilterableFieldsForFileUploads(onlyHasOneOri:boolean, submissionPeriodHidden:boolean){
        var filterableFields = baseStore.getFilterableFieldsForFileUploads(onlyHasOneOri,submissionPeriodHidden);

        var agencyFilter = filterableFields.find(f=>f.property=="agency");
        if(agencyFilter){
            agencyFilter.editorOptions = oriStore.getOrisAsBFieldSelectionArray;
        } 

        return filterableFields;
    }
    var errorDescriptionsDownloadUrl = ref(baseStore.errorDescriptionsDownloadUrl);

    //ori related functions & computed properties        
    const {oris, getOriName, getOrisForSelectList, getOrisAsBFieldSelectionArray, getDetailsForCurrentDataset, getSelectedOri } = storeToRefs(oriStore)    
    var fetchDatasetDetailsForOri = oriStore.fetchDatasetDetailsForOri; 
    var reset = oriStore.reset;
    var setSelectedOri = oriStore.setSelectedOri;
    var checkIfDownloadValid = baseStore.checkIfDownloadValid;

    return {getColumns, getStatisticsColumns, getFilterableFields, getValidationMessagesColumns, getValidationMessagesFilterableFields, 
        showWarningDetails,errorCodes,errorDescriptions,getValidationMessagesForFile, getRecordDetails, getErrorsAndWarnings, 
        getErrorsAndWarningsForFile, getFiles, getOriName, getOrisForSelectList, getOrisAsBFieldSelectionArray,
        getDetailsForCurrentDataset, fetchDatasetDetailsForOri, reset, getSelectedOri, setSelectedOri, errorDescriptionsDownloadUrl,
        getFileUploadColumns, getFilterableFieldsForFileUploads, getErrorsAndWarningsColumns, getFilterableFieldsForErrorsAndWarnings,oris, checkIfDownloadValid 
    };    
})